import { translate } from '@openclassrooms/translations';
import error410Src from '@classify/illustrations/error410';

import ErrorWrapper, { Props } from '../components/ErrorWrapper';

const Error410 = (props: Partial<Props>) => (
  <ErrorWrapper
    httpStatus={410}
    hasButton
    pictureUrl={error410Src}
    pictureWidth={550}
    titleLabel={translate('errors.error410.title')}
    detailsLabel={translate('errors.error410.subtitle')}
    {...props}
  />
);

export default Error410;
